export default "__VITE_ASSET__BdEoHPRW__"